import { render, staticRenderFns } from "./promotionContent.vue?vue&type=template&id=5ff697b8&scoped=true"
import script from "./promotionContent.vue?vue&type=script&lang=js"
export * from "./promotionContent.vue?vue&type=script&lang=js"
import style0 from "./promotionContent.vue?vue&type=style&index=0&id=5ff697b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff697b8",
  null
  
)

export default component.exports